import customAxios from "./axiosConfig";

const CarsService = {
    list: function (params, companyId) {
        /** List of cars that a user has access when he adds to a specific company. He has access to:
         *  - his personal cars
         *  - the company cars that he currently looks at
         * */

        var api_url = window.Urls['car-list']();

        return customAxios.get(api_url, {params: params}).then(function(success){
            var data = success.data;
            var filteredArray = [];
            for (var i=0; i<data.length; i++){
                if((data[i].user && !data[i].company_profile) || data[i].company_profile === companyId){
                    filteredArray.push(data[i]);
                }
            }
            return filteredArray
        });
    },

    retrieve: function (carId) {
        var api_url = window.Urls['car-detail'](carId);
        return customAxios.get(api_url);
    },

    prepareDataForSubmit: function (car) {
        var data = JSON.parse(JSON.stringify(car));
        var date_value = Date.parse(data.used_from);
        if (date_value) {
            data.used_from = date_value.toString("yyyy-MM-dd");
        }else{
            delete data.used_from;
        }
        date_value = Date.parse(data.used_until);
        if (date_value){
            data.used_until = date_value.toString("yyyy-MM-dd");
        }else{
            delete data.used_until;
        }
        return data;
    },

    create: function (data) {
        var api_url = window.Urls['car-list']();
        return customAxios.post(api_url, data).then(function(success) {
            var data = success.data;
            window.mixpanel.track("Cars: create", {
                "is company car": !(!data.company_profile)
            });
            return success;
        });
    },
    update: function (pk, data) {
        var api_url = window.Urls['car-detail'](pk);
        return customAxios.put(api_url, data).then(function(success) {
            var data = success.data;
            window.mixpanel.track("Cars: edit", {
                "is company car": !(!data.company_profile)
            });
            return success;
        });
    },
    archive: function (pk, data){
        var api_url = window.Urls['car-archive'](pk);
        return customAxios.post(api_url, data).then(function(success) {
            var data = success.data;
            window.mixpanel.track("Cars: edit", {
                "is company car": !(!data.company_profile)
            });
            return success;
        });
    },
    listForCompany(company_id, params) {
        let api_url = window.Urls['car-list']()

        return customAxios.get(api_url, {params: params}).then((response) => {
            let data = response.data
            let filteredArray = []
            for (let i = 0; i < data.length; i++) {
                if((data[i].user && !data[i].company_profile) || data[i].company_profile==company_id) {
                    filteredArray.push(data[i])
                }
            }
            return filteredArray
        })
    }
}

export default CarsService;